import moment from 'moment';
import { Space } from 'antd';
import { useFormikContext } from 'formik';
import { FileTextOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import FormDatePicker from 'components/new-ui/composed/formDatePicker/FormDatePicker';
import { InvoiceFieldValues } from 'views/invoices/types';
import { ControlWrapper, SectionFormLabel, SectionFormRow } from './../styles';

export enum InvoiceFieldNames {
    INVOICE_NUMBER = 'invoiceDetails.invoiceNumber',
    ORDER_NUMBER = 'invoiceDetails.orderNumber',
    MRN = 'invoiceDetails.mrn',
    JOB_REF_NUMBER = 'invoiceDetails.jobRefNumber',
    DUE_DATE = 'invoiceDetails.dueDate',
}

type Props = {
    isReadOnly: boolean;
};

const InvoiceDetailsSection = ({ isReadOnly }: Props) => {
    const formik = useFormikContext<InvoiceFieldValues>();

    return (
        <CardWithIcon
            gap="medium"
            layout="vertical"
            title="Invoice Details"
            iconProps={{
                size: 32,
                borderRadius: 8,
                status: 'warning',
                icon: <FileTextOutlined />,
            }}
            children={
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <SectionFormRow>
                        <SectionFormLabel>Invoice Number :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled
                                fieldProps={formik.getFieldProps(InvoiceFieldNames.INVOICE_NUMBER)}
                                fieldMeta={formik.getFieldMeta(InvoiceFieldNames.INVOICE_NUMBER)}
                                fieldHelper={formik.getFieldHelpers(InvoiceFieldNames.INVOICE_NUMBER)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Order Number :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled
                                fieldProps={formik.getFieldProps(InvoiceFieldNames.ORDER_NUMBER)}
                                fieldMeta={formik.getFieldMeta(InvoiceFieldNames.ORDER_NUMBER)}
                                fieldHelper={formik.getFieldHelpers(InvoiceFieldNames.ORDER_NUMBER)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>MRN :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled
                                fieldProps={formik.getFieldProps(InvoiceFieldNames.MRN)}
                                fieldMeta={formik.getFieldMeta(InvoiceFieldNames.MRN)}
                                fieldHelper={formik.getFieldHelpers(InvoiceFieldNames.MRN)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Job Ref Number :</SectionFormLabel>
                        <ControlWrapper>
                            <FormInput
                                disabled
                                fieldProps={formik.getFieldProps(InvoiceFieldNames.JOB_REF_NUMBER)}
                                fieldMeta={formik.getFieldMeta(InvoiceFieldNames.JOB_REF_NUMBER)}
                                fieldHelper={formik.getFieldHelpers(InvoiceFieldNames.JOB_REF_NUMBER)}
                            />
                        </ControlWrapper>
                    </SectionFormRow>

                    <SectionFormRow>
                        <SectionFormLabel>Due Date :</SectionFormLabel>
                        <ControlWrapper>
                            <FormDatePicker
                                disabled={isReadOnly}
                                disabledDate={(current) => current && current < moment().startOf('day')}
                                fieldName={InvoiceFieldNames.DUE_DATE}
                                placeholder="Select Date"
                                serializeDate={(value) => moment(value).format('YYYY-MM-DD')}
                                style={{
                                    pickerWrapper: {
                                        width: '100%',
                                    },
                                }}
                            />
                        </ControlWrapper>
                    </SectionFormRow>
                </Space>
            }
        />
    );
};

export default InvoiceDetailsSection;
